module.exports = __webpack_public_path__ + "static/how_it_works_practice_art-96ec4425ead38e227d66bbd5edcc42bf.png";